import React from 'react'
import ReactDOM from 'react-dom/client'
import { GoogleOAuthProvider } from '@react-oauth/google'
import './styles/index.css'
import './index.css'
import App from './App'
import { getGoogleClientId } from './config/environment'
import { PlatformFlagsProvider } from './context/PlatformFlagsContext'

const googleClientId = getGoogleClientId()

// Log Google Client ID status for debugging
if (googleClientId && !googleClientId.includes('your-') && googleClientId.length >= 20) {
  console.log('[Main] Google Client ID loaded:', googleClientId.substring(0, 30) + '...')
} else {
  console.warn('[Main] Google Client ID is missing or invalid:', googleClientId)
  console.warn('[Main] Please set VITE_GOOGLE_CLIENT_ID in your .env file')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <PlatformFlagsProvider>
        <App />
      </PlatformFlagsProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
)